module.exports = __webpack_public_path__ + "static/img/404.fffb2ee.png";


//////////////////
// WEBPACK FOOTER
// ./packages/404/404.png
// module id = B9hT
// module chunks = 0